var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLta = function SvgLta(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 2a6 6 0 0 0-6 6c0 3.314 2.686 8 6 8s6-4.686 6-8a6 6 0 0 0-6-6m0 14c-.53 0-1.04-.738-1.414-2.05C10.21 12.637 10 10.857 10 9s.21-3.637.586-4.95C10.96 2.738 11.47 2 12 2m0 14c.53 0 1.04-.738 1.414-2.05C13.79 12.637 14 10.857 14 9s-.21-3.637-.586-4.95C13.04 2.738 12.53 2 12 2m-2 18a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z"
  })));
};
export default SvgLta;